// @flow
import * as React from 'react';

type Value = {
  pushEvent?: (Object) => void,
};

const GTMContext = React.createContext<Value>({});

export const GTMProvider = ({ children }: { children: React.Node }) => {
  if (process.env.REACT_APP_RETAILER_APP_GTM_TRACKING_ID) {
    loadGTM({
      id: process.env.REACT_APP_RETAILER_APP_GTM_TRACKING_ID,
    });
  }

  const pushEvent = (option) => {
    if (process.env.REACT_APP_RETAILER_APP_GTM_TRACKING_ID) {
      // Clear the previous custom / ecommerce object.
      window.dataLayer.push({ custom: null });
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(option);
    }
  };

  return (
    <GTMContext.Provider
      value={{
        pushEvent,
      }}
    >
      {children}
    </GTMContext.Provider>
  );
};

export default GTMContext;

/**
 * Function enables Tag Manager to fire tags by inserting gtm.js into the page
 * @desc This is copy-paste script from below link
 * @link https://developers.google.com/tag-manager/quickstart
 * @param {Props} { id, dataLayerName = 'dataLayer' }
 */
const loadGTM = ({
  id,
  dataLayerName = 'dataLayer',
}: {
  id: string,
  dataLayerName?: string,
}) =>
  (function (window, document, script, datalayer, id) {
    window[datalayer] = window[datalayer] || [];
    window[datalayer].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const firstScript = document.getElementsByTagName(script)[0],
      gtmScript = document.createElement(script),
      dataLayerParam = datalayer !== 'dataLayer' ? '&l=' + datalayer : '';
    gtmScript.async = true;
    gtmScript.src =
      'https://www.googletagmanager.com/gtm.js?id=' + id + dataLayerParam;
    // $FlowFixMe
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  })(window, document, 'script', `${dataLayerName}`, `${id}`);
